export const CHECK_IN_PROMPTS = [
  { key: 'mind', text: 'What\u2019s on your mind this morning?' },
] as const;

export type CheckInPromptKey = (typeof CHECK_IN_PROMPTS)[number]['key'];
